module.exports = __webpack_public_path__ + "d77aee66e3eb28bc6c80604d603c84e4.png";